import { useRouteError, useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Message } from "primereact/message";

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();
  console.error(error);

  return (
    <div
      className="flex align-items-center justify-content-center min-h-screen"
    >
      <Card className="w-full md:w-6 lg:w-4 shadow-4 text-center">
        <div className="flex flex-column align-items-center gap-4">
          <i className="pi pi-exclamation-circle text-red-500" style={{ fontSize: "4rem" }} />
          <div className="flex flex-column gap-2">
            <h2 className="m-0 text-900">Une erreur est survenue</h2>
            <p className="m-0 text-600">
              Nous ne parvenons pas à charger cette page pour le moment.
              Veuillez actualiser ou retourner à l'accueil.
            </p>
          </div>
          {(error?.statusText || error?.message) && (
            <Message
              severity="error"
              className="w-full"
              text={error.statusText || error.message}
            />
          )}
          <div className="flex gap-3">
            <Button
              label="Actualiser"
              icon="pi pi-refresh"
              onClick={() => window.location.reload()}
            />
            <Button
              label="Retour à l'accueil"
              icon="pi pi-home"
              severity="secondary"
              outlined
              onClick={() => navigate("/")}
            />
          </div>
        </div>
      </Card>
    </div>
  );
}